import { render, staticRenderFns } from "./BankUndepositedFundView.vue?vue&type=template&id=192d919e"
import script from "./BankUndepositedFundView.vue?vue&type=script&lang=js"
export * from "./BankUndepositedFundView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports